import { render } from "./ConfirmsPassword.vue?vue&type=template&id=a61f1912"
import script from "./ConfirmsPassword.vue?vue&type=script&lang=js"
export * from "./ConfirmsPassword.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__